import React, { memo } from "react";
import FavIconBase from "../../../FavIcon";
import IconSrc from "icons/star.svg";

const FavIcon = (props) => {
  return <FavIconBase icon={IconSrc} {...props} />;
};

export default memo(FavIcon);
